var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateArrowBlack02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.40552,
    y: 16.7634,
    width: 17.888,
    height: 2.27149,
    transform: "rotate(-40.2798 4.40552 16.7634)",
    fill: "#00020F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93164,
    y: 5.69067,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 6.93164 5.69067)",
    fill: "#00020F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1328,
    y: 5.95459,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 10.1328 5.95459)",
    fill: "#00020F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3342,
    y: 6.21899,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 13.3342 6.21899)",
    fill: "#00020F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2717,
    y: 9.68457,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 16.2717 9.68457)",
    fill: "#00020F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0078,
    y: 12.8865,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 16.0078 12.8865)",
    fill: "#00020F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7429,
    y: 16.0879,
    width: 2.27149,
    height: 2.27149,
    transform: "rotate(-40.2798 15.7429 16.0879)",
    fill: "#00020F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowBlack02);
export default __webpack_public_path__ + "static/media/rotate-arrow-black02.955ea993ef71de237d3a6d49b710bac9.svg";
export { ForwardRef as ReactComponent };